import http from "@/plugins/http";
// 获取列表
export function getMenuList(data) {
    return http({
        url: `/menus/getMenuTree`,
        params: data,
        method: "GET"
    });
}

// 新增
export function createMenu(data) {
  console.log(data);
  return http({
    url: `/menus/add`,
    data: data,
    method: "POST"
  });
}

// 编辑
export function editMenu(data) {
    console.log(data);
    return http({
        url: `/menus/update`,
        data:data,
        method: 'POST',
    })
}

// 删除
export function deleteMenu(data) {
  console.log(data);
  return http({
      url: `/menus/delete`,
      params: data,
      method: "GET"
  });
}

// 移动菜单
export function moveMenu(data) {
    return http({
        url: `/menus/moveMenu`,
        params: data,
        method: "GET"
    });
}